/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//before dom content loaded
window.addEventListener("load", function () {
    

});
        
document.addEventListener("DOMContentLoaded", async function () {

    if (window.location.href.includes("collection")) {

    }

    await removeDiscountFromCart();
    




    window.ZapietEvent.listen('widget_loaded', function () {
        getStoreDetails(true);
    });

  
    window.ZapietEvent.listen('pickup.timepicker.rendered', function () {
        var el = document.getElementById('cart-recap__scroller');
        var items = document.getElementById('cart__product-table').childElementCount;

        if (window.screen.width < 1000) {
            var textWithIcons = document.getElementById("text-with-icons__section");
            if (textWithIcons != null) {
                textWithIcons.style.marginTop = "350px";

            }
            var addedHeight = items * 130;
            document.getElementById("cart__section").style.height = el.offsetHeight + addedHeight + 150 + "px";
        }
        else {
            var addedHeight = items * 100;
            document.getElementById("cart__section").style.height = el.offsetHeight + addedHeight + "px";
        }

    });
});


async function removeDiscountFromCart() {

    //if url is /cart
    if (window.location.href.includes("cart")) {

        //get cart from window.cart
        var changed = false;

        var newItems = [];

        cart.items.forEach(async function (item) {
            var newItem = item;
            var properties = item.properties;
            newItem.properties = "";
            newItems.push(newItem);

            if (properties.hasOwnProperty("MwSt.")) {
                changed = true;
            };
        });

        if (changed) {
            cart = await clearCart(cart.token); 

            body = { "items": newItems };
            console.log(cart, "cart");
            console.log(body, "new items");

            await fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
                body: JSON.stringify(body),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Accept": "application/json",
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                console.log(data);
            }).catch(function (error) {
                console.error(error);
            });
        }

        if(changed){
            location.reload();
        }
        // cart.items.forEach(async function (item) {

        //     //if item.properties is json, check if it contains key mwst
        //     var properties = item.properties;
        //     console.log(properties, "item properties");
        //     if (properties.hasOwnProperty("MwSt.")) {
        //         console.log("item has discount");
        //         await removeDiscountFromCartItem(item);
        //     }
        //     //if last item in cart and changed = true, refresh
        //     console.log(changed, "changed")

        //     if (item === cart.items[cart.items.length - 1] && changed) {
        //         location.reload();
        //     }
 

        // });
        // await fetch("".concat(window.routes.cartUrl, ".js"), {
        //     credentials: 'same-origin',
        //     method: 'GET',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         "Accept": "application/json",
        //         'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        //     }
        // }).then(function (response) {
        //     return response.json();
        // }).then(function (cart) {
        //     //foreach item in cart remove discount

            
            
            
        // });

    }

}
async function clearCart (cartToken){
    return fetch("".concat(window.routes.cartUrl, "/clear.js"), {
        credentials: 'same-origin',
        body: JSON.stringify({
            "token": cartToken
        }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json",
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
    }).then(function (response) {
        return response.json();
    }).then(function (cart) {
        console.log(cart);
        return cart;
    });
}
async function removeDiscountFromCartItem(item) {

    var newCartItem = item;
    newCartItem.properties = "";
    var itemKey = item.key;
    var itemVariant = item.id;

    var body = {
        "updates": {
            [itemKey]: 0
        }
    };
    //remove discount
    await fetch("".concat(window.Shopify.routes.root, "cart/update.js"), {
        body: JSON.stringify(body),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Accept": "application/json",
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
    }).then(function (response) {
        return response.json(); // Parse the response as JSON
    }).then(async function (data) {

        //add item without discount
        body = { "items": [newCartItem] };
        await fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
            body: JSON.stringify(body),
            credentials: 'same-origin',

            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            console.log(data);
        }).catch(function (error) {
            console.error(error);
        });
        console.log(data); // Log the parsed JSON response
    }).catch(function (error) {
        console.error(error); // Log any errors
    });
}

function fetchStoreDetails(request) {
    return fetch("https://api-us.zapiet.com/v1.0/pickup/locations?api_key=e8ca34f81a1cfb3b58c71904450da9b6&shop=isolarpro.myshopify.com", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
    }).then((response) => response.json())
        .then((responseData) => {
            return responseData;
        });
}


async function getStoreDetails(firstime) {

    var qtyInput = document.getElementById("quantity-selector__increase");
    for (var i = 0; i < qtyInput.length; i++) {

        qtyInput[i].onblur = function () {
            setTimeout(function () {
                getStoreDetails(false);
            }, 1750);
        };
    };

    var qtySelector = document.getElementById("quantity-selector__value");
    for (var i = 0; i < qtySelector.length; i++) {
        qtySelector[i].onclick = function () {
            setTimeout(function () {
                getStoreDetails(false);
            }, 1750);
        }
    };

    var qtyDecrease = document.getElementById("quantity-selector__decrease");
    for (var i = 0; i < qtyDecrease.length; i++) {
        qtyDecrease[i].onclick = function () {
            setTimeout(function () {
                getStoreDetails(false);
            }, 1750);
        }
    };

    var qtyRemove = document.getElementById("quantity-selector__remove");
    for (var i = 0; i < qtyRemove.length; i++) {
        qtyRemove[i].onclick = function () {
            setTimeout(function () {
                getStoreDetails(false);
            }, 1750);
        }
    };

    var cartItems = document.getElementById("cart__product-table").children;

    var pickupContainers = document.getElementsByClassName("pickupContainer");

    while (pickupContainers.length > 0) {
        pickupContainers[0].parentNode.removeChild(pickupContainers[0]);
    }

    var shippingContainers = document.getElementsByClassName("pickupContainer");
    while (shippingContainers.length > 0) {
        shippingContainers[0].parentNode.removeChild(shippingContainers[0]);
    }

    for (let i = 0; i < cartItems.length; i++) {
        var prodCard = cartItems[i];
        var productId = prodCard.getAttribute("data-product-id");
        var variantId = prodCard.getAttribute("data-variant-id");
        var qty = prodCard.getAttribute("data-quantity");
        var shipping = prodCard.getAttribute("data-shipping");
        var handle = prodCard.getAttribute("data-product-handle");
        var request = {
            "shoppingCart": [
                {
                    "variant_id": variantId,
                    "product_id": productId,
                    "quantity": qty
                }
            ]
        };

        var responseData = await fetchStoreDetails(request);

        var parElement = prodCard.getElementsByClassName("line-item__product-info")[0];

        if (parElement) {

            var shippingHeading = document.createElement("div");
            shippingHeading.classList.add("shippingContainer;");
            var pickupHeading = document.createElement("div");
            pickupHeading.classList.add("pickupContainer");


            responseData.locations.forEach((loc, index) => {
                var shippingShown = document.getElementsByClassName("shippingIcon").length > 0;
                var pickupShown = document.getElementsByClassName("pickupIcon").length > 0;


                if (shippingShown && index == 0 && shipping.includes("true")) {
                    parElement.appendChild(shippingHeading);
                    var heading = document.createTextNode("Wird versendet aus: ");
                    var p = document.createElement("p");
                    var text = document.createTextNode("- " + loc.company_name);
                    console.log("info added");
                    p.classList.add("shippingHeading");
                    p.appendChild(heading);

                    shippingHeading.appendChild(p);
                    var cartSection = document.getElementById("cart__section");
                    document.getElementById("cart__section").style.height + 50 + "px";
                }

                if (pickupShown && index == 0) {
                    //if parelement already has pickupheading, skip
                    if (parElement.getElementsByClassName("pickupHeading").length > 0) {
                        console.log("pickup heading already exists");
                        return;
                    }

                    parElement.appendChild(pickupHeading);
                    var heading = document.createTextNode("Zur Abholung verfügbar in: ");
                    var p = document.createElement("p");
                    var text = document.createTextNode("- " + loc.company_name);
                    console.log("info added");
                    p.classList.add("pickupHeading");
                    p.appendChild(heading);
                    pickupHeading.appendChild(p);
                    var cartSection = document.getElementById("cart__section");
                    document.getElementById("cart__section").style.height + 50 + "px";
                }



                if (loc.company_name.toLowerCase().includes("versandlager")) {


                    if (pickupShown) {
                        var p = document.createElement("p");
                        var text = document.createTextNode("- " + loc.company_name);
                        p.appendChild(text);
                        p.classList.add("cartLocationName");
                        pickupHeading.appendChild(p);
                        var cartSection = document.getElementById("cart__section");
                        document.getElementById("cart__section").style.height + 50 + "px";
                    }

                    if (shippingShown) {
                        var p = document.createElement("p");
                        var text = document.createTextNode("- " + loc.company_name);
                        p.appendChild(text);
                        p.classList.add("cartLocationName");
                        shippingHeading.appendChild(p);
                        var cartSection = document.getElementById("cart__section");
                        document.getElementById("cart__section").style.height + 50 + "px";
                    }
                } else {
                    var p = document.createElement("p");
                    var text = document.createTextNode("- " + loc.company_name);
                    p.appendChild(text);
                    p.classList.add("cartLocationName");
                    if (pickupShown) {
                        pickupHeading.appendChild(p);
                        var cartSection = document.getElementById("cart__section");
                        document.getElementById("cart__section").style.height + 50 + "px";
                    }

                }

            });
        }
    }

}